import styled from 'styled-components';

export default styled.div`
  grid-area: ${({ area }) => area};
  min-width: 2rem;
  font-weight: 500;
  text-align: center;
  padding: 0 0.25rem;
  color: black;
`;
